function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "HomeMenu-icon-Lessons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "asignaciones-37",
  transform: "translate(5.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.23,15.993 L66.189,36.146 C61.4036144,37.4911239 56.3982119,37.8694867 51.465,37.259 L34.583,37.746 L17.701,37.259 C12.7702837,37.8653065 7.76825591,37.4866534 2.985,36.145 L6.944,15.993 C11.3165543,17.3199053 16.0106704,17.1178068 20.253,15.42 C22.898,14.531 29.432,11.174 34.59,13.579 C39.749,11.175 46.284,14.52 48.928,15.42 C53.1686846,17.1141243 57.8593413,17.3161801 62.23,15.993 Z",
  id: "Trazado_134",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.949,18.599 L6.434,18.599 L3.202,35.256 C17.002,39.718 21.569,32.756 34.591,36.872 C47.614,32.75 52.176,39.718 65.98,35.256 L62.74,18.599 L64.225,18.599 L69.17,38.868 L40.224,37.868 C39.624,39.306 30.202,39.306 29.498,37.868 L-0.002,38.868 L4.949,18.599 Z",
  id: "Trazado_135",
  fill: "#D99289"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.693,13.175 C21.507,17.444 20.533,9.525 33.061,13.198 L33.061,34.243 C20.038,30.121 19.261,36.277 5.461,31.807 L8.693,13.175 Z M60.475,13.175 C47.661,17.444 48.635,9.525 36.107,13.198 L36.107,34.243 C49.13,30.121 49.907,36.277 63.707,31.807 L60.475,13.175 Z",
  id: "Trazado_136",
  fill: "#C1BCB4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.285,12.667 L7.741,29.526 C11.5643012,30.7078624 15.5991143,31.0429594 19.565,30.508 C26.873,30.208 28.35,31.521 33.5,34.746 L33.5,13.201 C29.8495499,11.4858293 25.7090252,11.121208 21.815,12.172 C18.1448065,13.6665495 14.0697796,13.8414964 10.285,12.667 L10.285,12.667 Z",
  id: "Trazado_137",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.889,12.667 L61.434,29.526 C57.6106988,30.7078624 53.5758857,31.0429594 49.61,30.508 C42.302,30.208 40.825,31.521 35.675,34.746 L35.675,13.201 C39.3254501,11.4858293 43.4659748,11.121208 47.36,12.172 C51.0298968,13.6663119 55.1045277,13.841257 58.889,12.667 Z",
  id: "Trazado_138",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.908,13.44 L34.908,34.026 L34.274,34.026 L34.274,13.44 C34.382,13.486 34.491,13.533 34.591,13.579 C34.692,13.533 34.8,13.486 34.908,13.44 Z",
  id: "Trazado_139",
  fill: "#E4E3DD"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_71",
  transform: "translate(23.192000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.798,11.399 C22.798,17.6950461 17.6940461,22.799 11.398,22.799 C5.10195385,22.799 -0.002,17.6950461 -0.002,11.399 C-0.002,5.10295385 5.10195385,-0.001 11.398,-0.001 C17.6940461,-0.001 22.798,5.10295385 22.798,11.399 Z",
  id: "Trazado_140",
  fill: "#7DD577"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_69",
  transform: "translate(3.310000, 6.535000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Trazado_141",
  points: "8.762 9.752 6.411 12.095 0 5.684 2.351 3.333 6.411 7.401"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Trazado_142",
  points: "16.163 2.366 8.763 9.751 6.408 12.095 4.068 9.752 6.408 7.4 13.808 0"
})))));
function SvgHomeMenuIconLessons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeMenu-icon-Lessons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIconLessons);
export default __webpack_public_path__ + "static/media/HomeMenu-icon-Lessons.6badc6b6adaef4e7263658da3c2d9f49.svg";
export { ForwardRef as ReactComponent };